/* RESPONSIBLE TEAM: team-proactive-support */
import NodeConfiguration, { NODE_CATEGORIES } from 'embercom/objects/series/node-configuration';
import EmailInserterConfiguration from 'embercom/objects/series/node/email-inserter-configuration';

export default class EmailNodeConfiguration extends NodeConfiguration {
  inserterConfiguration = new EmailInserterConfiguration();
  category = NODE_CATEGORIES.content;
}
